var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('paginated-search',_vm._b({},'paginated-search',{ schema: _vm.schema, searchEntities: _vm.searchEntities, exportEntity: _vm.exportEntity, autoEnable: true },false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }